import { create } from 'utils/API';
import { useMutation } from 'react-query';
import { FOOTPRINT_TRACKING_ENDPOINT } from 'constants/footPrintTracking';

export function useFootPrintTrackingMutation(options = {}) {
  return useMutation(
    payload => create(FOOTPRINT_TRACKING_ENDPOINT, payload),
    {
      onSuccess: () => {
        if (typeof options?.onSettled === 'function') {
          const { onSettled } = options;
          onSettled();
        }
      },
    },
    options,
  );
}
